(ns superadmin.agency-ocp.view
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/Typography$default" :as Typography]
            [cljs-bean.core :refer [->clj]]
            [common.ocp.view :refer [defocp ocp]]
            [common.queries :refer [use-query use-mutation]]
            [common.resource.query.agency :as agency.q]
            [common.util :refer [spread-props]]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [re-frame.core :as rf]
            [superadmin.agency-ocp.db :as form]
            [uix.core :as uix :refer [$]]
            [uix.re-frame :refer [use-subscribe]]))

(defocp agency-ocp :agency/crud [agency]
  (uix/use-effect (fn []
                    (rf/dispatch [:form.agency/init-form])
                    (fn []
                      (rf/dispatch [:form.agency/destroy])))
                  [])
  (let [{{tenants :all-tenants mapped-tenants :mapped-tenants} :data} (use-query (agency.q/all-tenants-query))
        edit-mode (some? agency)
        mapped-tenants-set (->> mapped-tenants keys (map name) set)
        title (if edit-mode "Update Agency" "Create Agency")
        value->option (->> tenants (map (juxt :id identity)) (into {}))
        {:keys [on-change value]} (form/use-bind-control [:tenant])
        {refresh-tenants :mutate} (use-mutation (agency.q/refresh-all-tenants-mutation))
        {update-tenant :mutate} (use-mutation (agency.q/update-tenant-mutation (:id agency)))]
    (uix/use-effect
     (fn []
       ;; This is needed to trigger BE to fetch tenants detailed data e.g. name, azId etc.
       ;; to use it for setting correct tenant data to Agency after patch.
       (refresh-tenants))
     [refresh-tenants])
    ($ ocp
       {:title title
        :footer (let [errors (use-subscribe [:form.agency/errors?])]
                  ($ Button
                     {:type "submit"
                      :variant "contained"
                      :disabled errors
                      :data-testid "agency-submit"}
                     title))
        :on-submit #(if edit-mode
                      (update-tenant value)
                      (rf/dispatch [:form.agency/submit]))}
       (let [name-bind (form/use-bind-control [:name])
             error-bind (form/use-error-message [:name])]
         (if edit-mode
           ($ Typography (:name agency))
           ($ form-field
              {:label "Name"
               :err-msg error-bind
               :data-testid :agency-ocp--name}
              ($ input
                 (merge name-bind
                        {:type "text"
                         :data-testid "agency-name-input"})))))
       (when edit-mode
         ($ Autocomplete
            {:disableClearable true
             :options (to-array (map #(assoc % :used (some? (mapped-tenants-set (:id %)))) tenants))
             :getOptionLabel (fn [option] (or (:name option) ""))
             :value (or (get value->option (or value (-> agency :tenantInfo :id))) "")
             :onChange (fn [^js _event new-value]
                         (on-change (:id new-value)))
             :renderInput (fn [^js props]
                            ($ TextField
                               (spread-props props {:fullWidth true})))
             :render-option (fn [^js props option ^js _option-state _owner-state]
                              (let [mapped? (-> option ->clj :used)
                                    color (if mapped? "grey.40" "text.primary")]
                                ($ :li props
                                   ($ Typography
                                      {:sx #js {:color color}}
                                      (:name option)))))
             :sx #js {".MuiOutlinedInput-root" #js {:paddingRight "0.5rem !important"}}})))))
